<template>
  <div class="container p-1" id="header">
    <div class="row justify-content-between align-items-center">
      <div class="col-lg-3 col-sm-2">
        <div class="lcn-logo">
          <img
            src="../assets/LCN-Logo-Gelb-Schwarz-WEB.png"
            alt=""
            width="242"
          />
        </div>
      </div>
      <div class="col-lg-3 col-sm-4">
        <div class="">
          <img src="../assets/header_versuch1-small.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#header {
  height: 80px;
}
</style>
